import React, { useState } from 'react'
import Title from './Title';
import WebDesign from '../images/portfolio.png'
import WebApp from '../images/WebApp.png'
import Maintainance from '../images/Maintaince.png'
import WebDev from '../images/Development.png'
import Bubbles from './Bubbles';

const services = [
  {
    image: WebDesign,
    title: "UI/UX Design",
    description: "Creating intuitive, visually compelling interfaces that elevate user experience and brand perception.",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245 4.5 4.5 0 008.4-2.245c0-.399-.078-.78-.22-1.128zm0 0a15.998 15.998 0 003.388-1.62m-5.043-.025a15.994 15.994 0 011.622-3.395m3.42 3.42a15.995 15.995 0 004.764-4.648l3.876-5.814a1.151 1.151 0 00-1.597-1.597L14.146 6.32a15.996 15.996 0 00-4.649 4.763m3.42 3.42a6.776 6.776 0 00-3.42-3.42" />
      </svg>
    ),
  },
  {
    image: WebApp,
    title: "Web Application",
    description: "Building robust, scalable web applications with modern architectures and real-time capabilities.",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 7.5l3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0021 18V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v12a2.25 2.25 0 002.25 2.25z" />
      </svg>
    ),
  },
  {
    image: WebDev,
    title: "Web Development",
    description: "End-to-end development from concept to deployment, using React, Node.js, Laravel and modern stacks.",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5" />
      </svg>
    ),
  },
  {
    image: Maintainance,
    title: "Maintenance & Support",
    description: "Ongoing technical support, performance optimization, and feature enhancements for existing platforms.",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M11.42 15.17l-5.384 3.18A1.5 1.5 0 014 17.035V6.965a1.5 1.5 0 012.036-1.415l5.384 3.18m0 0l5.384 3.18A1.5 1.5 0 0119.5 13.5V5.25m0 0l-5.384 3.18m5.384-3.18v8.25" />
      </svg>
    ),
  },
];

const ServiceCard = ({ service, index }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <article
      className="bg-primary-card rounded-2xl overflow-hidden border border-primary-border card-hover cursor-pointer group relative"
      data-aos="fade-up"
      data-aos-duration="700"
      data-aos-delay={index * 120}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Image section */}
      <div className="overflow-hidden relative h-40 sm:h-44">
        <img
          className={`w-full h-full object-cover transition-transform duration-700 ${isHovered ? 'scale-110' : 'scale-100'}`}
          src={service.image}
          alt={`${service.title} — Nang Myintzu WeTech`}
          loading="lazy"
          width="400"
          height="176"
        />
        <div className={`absolute inset-0 transition-all duration-500 ${
          isHovered ? 'bg-accent/20' : 'bg-black/30'
        }`} />

        {/* Icon overlay */}
        <div className={`absolute top-3 right-3 sm:top-4 sm:right-4 p-2.5 sm:p-3 rounded-xl transition-all duration-500 ${
          isHovered
            ? 'bg-accent text-primary-bg shadow-accent-lg scale-110 rotate-12'
            : 'bg-primary-bg/60 text-accent backdrop-blur-sm'
        }`}>
          {service.icon}
        </div>
      </div>

      {/* Content */}
      <div className="p-4 sm:p-5">
        <h3 className={`font-bold text-sm sm:text-base lg:text-lg uppercase transition-colors duration-300 ${
          isHovered ? 'text-accent' : 'text-white'
        }`}>
          {service.title}
        </h3>
        <p className="text-gray text-xs sm:text-sm mt-2 leading-relaxed">
          {service.description}
        </p>

        {/* Animated underline */}
        <div className="mt-3 sm:mt-4 overflow-hidden">
          <div className={`h-[2px] bg-gradient-to-r from-accent to-accent/30 transition-all duration-500 ${
            isHovered ? 'w-full' : 'w-0'
          }`} />
        </div>
      </div>
    </article>
  );
};

const Services = () => {
  return (
    <section id="services" className="relative bg-primary-dark py-16 sm:py-20 lg:py-24 overflow-hidden noise-overlay">
      <div className="absolute inset-0 gradient-mesh pointer-events-none" />
      <Bubbles count={6} />

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <Title>Services</Title>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 lg:gap-6 mt-10 sm:mt-12">
          {services.map((service, index) => (
            <ServiceCard key={index} service={service} index={index} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Services
